import { useQuery } from '@tanstack/react-query';

import { getLocationGroups, type LocationGroupsResult } from '../services/locationGroupsService';

export function useLocationGroups(locationCode: string | null) {
  return useQuery<LocationGroupsResult>({
    queryKey: ['location-session', 'groups', locationCode],
    queryFn: () => getLocationGroups(locationCode as string),
    enabled: !!locationCode,
    staleTime: 5 * 60 * 1000,
  });
}
